const createPageUrl = (page) => {
  // For client-expense-loop, we need to use the basename "/expense-loop"
  return `/${page}`;
};

export default createPageUrl;
